/* Sniggles predictive search (Oct 11 2026, FQ website list #5).
   The header search, the /search page form, and any form marked
   [data-sn-predictive] get a results panel as you
   type: suggested searches, brands, categories and products, rendered by
   sections/sniggles-predictive-search.liquid through Shopify's Predictive
   Search API. Synonyms come from the Search & Discovery app automatically.
   Keyboard: ↓/↑ move through results, Esc closes, Enter on the field still
   submits the full search. No framework, no dependencies. */
(function () {
  var MIN = 2, WAIT = 180;

  function init(form) {
    if (!form || form.dataset.snPsReady === '1') return;
    form.dataset.snPsReady = '1';
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var base = form.getAttribute('data-sn-predictive') || (root + 'search/suggest');

    var panel = document.createElement('div');
    panel.className = 'sn-ps-panel';
    panel.id = 'sn-ps-' + Math.random().toString(36).slice(2, 8);
    panel.hidden = true;
    form.appendChild(panel);

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');

    var timer, ctrl, last = '';

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function run() {
      var q = input.value.trim();
      if (q.length < MIN) { last = ''; close(); return; }
      if (q === last && !panel.hidden) return;
      last = q;
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = base + '?q=' + encodeURIComponent(q) +
        '&section_id=sniggles-predictive-search' +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      // Shopify's predictive API does not serve Arabic (HTTP 417); fall back
      // to the normal storefront search, which does, rendered by the same section.
      var fallback = root + 'search?q=' + encodeURIComponent(q) +
        '&type=product&options%5Bprefix%5D=last&section_id=sniggles-predictive-search';
      var opts = ctrl ? { signal: ctrl.signal } : {};
      fetch(url, opts)
        .then(function (r) {
          if (r.ok) return r.text();
          return fetch(fallback, opts).then(function (r2) { return r2.ok ? r2.text() : ''; });
        })
        .then(function (html) {
          if (q !== input.value.trim()) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-sn-ps-results]');
          if (!res) { close(); return; }
          panel.innerHTML = '';
          panel.appendChild(document.importNode(res, true));
          open();
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(run, WAIT);
    });
    input.addEventListener('focus', function () {
      if (panel.innerHTML && input.value.trim().length >= MIN) open();
    });

    function items() { return Array.prototype.slice.call(panel.querySelectorAll('[data-sn-ps-item]')); }

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); return; }
      if (panel.hidden || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      var list = items();
      if (!list.length) return;
      e.preventDefault();
      var i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') i = i < list.length - 1 ? i + 1 : 0;
      else i = i <= 0 ? -1 : i - 1;
      if (i === -1) input.focus(); else list[i].focus();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function boot() {
    document.querySelectorAll('form[data-sn-predictive], form.sn-header__search, form.sn-search__form').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
